"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_FINANCE_ACCOUNTING_PERMISSIONS = exports.FinanceAccountingPermissions = void 0;
/**
 * Permission string catalog for the Finance Accounting bounded context
 * (Stage 13, Milestone 1). Format `<module>:<action>`, same convention
 * as every sibling catalog. Coarse, workflow-style grouping like
 * `financial.permissions.ts` — one permission per REST resource group,
 * not per individual operation.
 */
exports.FinanceAccountingPermissions = {
    /** createJournalEntry, submitJournalEntry — creating/submitting a manual voucher. */
    FINANCE_JOURNAL_CREATE: 'finance-accounting:journal:create',
    /** approveJournalEntry, rejectJournalEntry. */
    FINANCE_JOURNAL_APPROVE: 'finance-accounting:journal:approve',
    /** cancelJournalEntry — DRAFT/REJECTED only. */
    FINANCE_JOURNAL_CANCEL: 'finance-accounting:journal:cancel',
    /** reverseJournalEntry — POSTED only, the sole correction mechanism after posting. */
    FINANCE_JOURNAL_REVERSE: 'finance-accounting:journal:reverse',
    /** Account ledger inquiry, voucher drilldown, journal entry listing/read. */
    FINANCE_LEDGER_READ: 'finance-accounting:ledger:read',
    /** Trial Balance generation. */
    FINANCE_TRIAL_BALANCE_READ: 'finance-accounting:trial-balance:read',
    /** Chart of Accounts create/update — reuses `FinAccount`, gated separately from Financial Foundation's own permissions since this is the accounting-workflow surface, not master-data administration. */
    FINANCE_COA_MANAGE: 'finance-accounting:chart-of-accounts:manage',
    /** FinPostingRule/FinJournalTemplate create/update — configuring what Auto-Posting does. */
    FINANCE_POSTING_RULE_MANAGE: 'finance-accounting:posting-rule:manage',
    /** Accounting period lock/unlock/close. */
    FINANCE_PERIOD_MANAGE: 'finance-accounting:period:manage',
    /** Opening Balance import — deliberately separate from FINANCE_JOURNAL_CREATE (see journal-voucher.service.ts's own header comment on why OPENING entries have their own gate). */
    FINANCE_OPENING_BALANCE_IMPORT: 'finance-accounting:opening-balance:import',
};
/** Every Finance Accounting permission, flattened — used to seed the `permissions` table. */
exports.ALL_FINANCE_ACCOUNTING_PERMISSIONS = Object.values(exports.FinanceAccountingPermissions);
//# sourceMappingURL=finance-accounting.permissions.js.map